import styled from 'styled-components'

import Button from '@doordash/component-button'
import { Text, Colors, Spacing, StackChildren } from '@doordash/design-language'

type MobileProps = {
  mobile: boolean
}

interface IProps extends MobileProps {
  city: string
  cityOverride?: string
}

export const CardStackChildren = styled(StackChildren)`
  width: ${(props: IProps) => (props.city ? 'auto' : '50%')};
  display: flex;
  align-items: center;
`

// tslint:disable:max-line-length
const SPACING_LARGE = `${Spacing.Large}px`
const SYSTEM_TEAL_50 = `1px solid ${Colors.SystemTeal50}`
export const MobileCardStackChildren = styled(StackChildren)`
  margin: ${(props: IProps) => (props.cityOverride ? 'none' : SPACING_LARGE)};
  border: ${(props: IProps) => (props.cityOverride ? 'none' : SYSTEM_TEAL_50)};
`

export const SectionContainer = styled.div`
  margin-top: ${(props: IProps) =>
    props.city ? `${Spacing.XLarge}px` : '0 !important'};
  width: ${(props: IProps) =>
    props.city && !props.cityOverride ? '80vw' : '100vw'};
  border: ${(props: IProps) =>
    props.city && !props.cityOverride
      ? `1px solid ${Colors.SystemTeal50}`
      : 'none'};
`

export const SectionImage = styled.img`
  width: ${(props: IProps) => (props.mobile ? '100%' : 'auto')};
  ${props => {
    if (props.mobile) {
      return `height: auto`
    }
    return `max-width: 100%`
  }}
`

export const ContentContainer = styled.div`
  padding: ${(props: MobileProps) =>
    props.mobile ? `${Spacing.Large}px` : `${Spacing.XxxLarge}px`};
  padding-top: 0;
`

export const CityName = styled(Text)`
  color: ${Colors.SystemTeal50};
`

export const SectionTitle = styled(Text)``

export const SectionContent = styled(Text)``

export const OpportunityButton = styled(Button)``
